export default {"src":"/_next/static/media/location-mark.8185eeca.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};